import { typedHttp } from '../http';
import { replacePathParams } from '../http/replacePathParams';

import { type FetchSimilarItemsQueryParams } from './types';

import { SIMILAR_ITEMS_ENDPOINT } from '@/constants/endpoints';

export function fetchSimilarItems(
  productId: string,
  params?: FetchSimilarItemsQueryParams,
  withAuth?: boolean
) {
  return typedHttp.get(
    replacePathParams(SIMILAR_ITEMS_ENDPOINT, { productId }),
    {
      params,
      withAuth,
      withDeviceId: true,
    }
  );
}
